import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./pages/Errorboundry";
import { BrowserRouter } from "react-router-dom";
import { register } from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import "./App.css";
import "./index.css";
import "./custom-theme.less";
import { registerLicense } from "@syncfusion/ej2-base";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./app/store";
import { ThemeProvider } from "./utils/themeToggle/theme";
import { Divider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));
const registerLicenseKey =
  "Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9eeHRSQmRdVEVxV0pWYEA=";
registerLicense(registerLicenseKey);
register({
  onSuccess: (registration) => {
    console.log("Service worker registration successful:", registration);
  },
  onUpdate: (registration) => {
    console.log("Service worker update detected:", registration);
    if (window.confirm("A new version is available. Do you want to refresh?")) {
      window.location.reload();
    }
  },
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(function (registration) {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch(function (error) {
      console.error('Service Worker registration failed:', error);
    });
}
root.render(
  <div className="overflow-hidden">

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <ErrorBoundary>
            <BrowserRouter>
              <App className="scroll-smooth" />
            </BrowserRouter>
          </ErrorBoundary>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </div>
);
reportWebVitals();